export const environment = {
  basePath: import.meta.env.BASE_URL,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  cloudflareEnvironment: import.meta.env.VITE_CLOUDFLARE_ENV ?? 'production',
  appVersion: __APP_VERSION__,
};
